import { render } from "./ErrorDetailView.vue?vue&type=template&id=2a222a13"
import script from "./ErrorDetailView.vue?vue&type=script&lang=js"
export * from "./ErrorDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__